"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const io_1 = require("react-icons/io");
const SosRemorquagesAdminTable_1 = __importDefault(require("./Tables/SosRemorquagesAdminTable"));
const fa6_1 = require("react-icons/fa6");
const axios_1 = __importDefault(require("axios"));
const hook_1 = require("../../../redux/hook");
const SosRemorquagesAdmin = () => {
    const [search, setSearch] = react_1.default.useState("");
    const [dateRange, setDateRange] = react_1.default.useState("");
    const [isLoading2, setIsLoading2] = react_1.default.useState(false);
    const { token } = (0, hook_1.useAppSelector)((state) => state.user);
    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };
    const handleDateRangeChange = (e) => {
        setDateRange(e.target.value);
    };
    const exportSosTowings = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading2(true);
        try {
            const response = yield axios_1.default.get(`/api/v1/app/exportSosTowings`, {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            const resp = response.data;
            if (resp.success) {
                const fileUrl = resp.file_url;
                const fullFileName = fileUrl.split("/").pop() || "export.xlsx";
                const baseName = fullFileName.replace(/\.[^/.]+$/, "");
                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", `${baseName}.xlsx`);
                link.setAttribute("target", "_blank");
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading2(false);
        }
    });
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Sos Remorquage"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-titre-page" }, "Sos Remorquage"),
                                react_1.default.createElement("div", { className: "sunu-autoroute-admin-btn-add-container" },
                                    react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-import", onClick: exportSosTowings },
                                        react_1.default.createElement(fa6_1.FaFileExport, null),
                                        isLoading2 ? "En cours.." : 'Exporter les Sos Remorquages')))),
                        react_1.default.createElement("div", { className: "row mb-4" },
                            react_1.default.createElement("div", { className: "col-lg-12" },
                                react_1.default.createElement("div", { className: "pb-4 search-group-wrapper" },
                                    react_1.default.createElement("div", { className: "search-form-group position-relative" },
                                        react_1.default.createElement("span", { className: "search-input-icon" },
                                            react_1.default.createElement(io_1.IoMdSearch, null)),
                                        react_1.default.createElement("input", { type: "search", className: "form-control search-form-control", id: "search", "aria-label": "UsernSearchame", placeholder: "Rechercher...", value: search, onChange: handleSearchChange }))),
                                react_1.default.createElement("div", { className: "table--wrapper admin-table--wrapper" },
                                    react_1.default.createElement(SosRemorquagesAdminTable_1.default, { search: search, dateRange: dateRange }))))))))));
};
exports.default = SosRemorquagesAdmin;
